var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfRedIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.36865 13.0259C5.05453 13.2578 2.39137 14.2648 3.5085 15.4995C4.97718 17.1229 6.98712 12.801 7.21902 11.4025L8.30124 7.61479C8.53314 6.53259 8.1621 5.6668 6.98712 6.53257C6.49754 7.12521 6.12134 8.83614 8.53314 10.9387C9.69255 11.9495 10.5429 13.0259 12.0117 13.2578C12.5013 13.1547 13.1712 12.6394 12.3209 11.7891C11.7025 11.1706 9.80089 11.5417 8.06934 12.4075L6.36865 13.0259Z",
    stroke: "#E95A5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.31412 1C1.44835 1 1.0773 1.77301 1 2.15952V18.702C1 19.7533 2.03068 20.0161 2.54603 20.0161H13.832C14.8833 19.9543 15.0431 18.6505 14.9915 18.0063V5.40618L10.8173 1H2.31412Z",
    stroke: "#E95A5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8174 1.23193V4.16938C10.8431 4.42706 11.1266 4.95786 12.0542 5.0197H14.5278",
    stroke: "#E95A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfRedIcon);
export default __webpack_public_path__ + "static/media/pdf-red-icon.c1f6342f4a39fd3c46423f07cf6a6ffe.svg";
export { ForwardRef as ReactComponent };